import React from 'react';
import {Dialog, DialogContent} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {BlueButton, OutlinedButton, WhiteButton} from "../../../common/buttons";
import {makeStyles} from "@material-ui/core/styles";
import {ReactComponent as ErrorIcon} from '../../../../assets/error.svg'


const useStyles = makeStyles(theme => ({

    dialogRoot: {
        '&&': {
            padding: '40px 25px 25px 43px',
            maxWidth: 453
        }
    },

    errorIcon: {
        marginLeft: 15
    },

    header: {
        color: theme.palette.warning.main,
        marginBottom: 22
    },

    bodyText: {
        color: '#b2b2b2',
        marginBottom: 45
    }

}));

const CautionDialog = ({open, onSuccess, onCancel}) => {
    const classes = useStyles();

    return (
        <Dialog open={open}>
            <DialogContent classes={{root: classes.dialogRoot}}>
                <Grid container direction={'column'}>
                    <Grid item container alignItems={'center'} direction={'row'} className={classes.header}>
                        <Typography variant={'h1'}>
                            Caution
                        </Typography>
                        <ErrorIcon className={classes.errorIcon}/>
                    </Grid>
                    <Grid item xs>
                        <Typography variant={'h3'} className={classes.bodyText}>
                            This action <strong> will create a new school account</strong> Are you sure you want to add
                            the submited
                            school information?
                        </Typography>
                    </Grid>
                    <Grid item container justify={'space-between'}>
                        <Grid item>
                            <WhiteButton variant="outlined" color="primary" onClick={onCancel}>Cancel</WhiteButton>
                        </Grid>
                        <Grid item>
                            <BlueButton onClick={onSuccess}>Create</BlueButton>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default CautionDialog;
